import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { MUILicenseInfo, MUI_LICENSE } from '../../../licensing';
import { theme } from './Theme.constants';
export function Theme({ children, injectFirst, noLicense }) {
    if (!noLicense) {
        MUILicenseInfo.setLicenseKey(MUI_LICENSE);
    }
    if (injectFirst) {
        return (React.createElement(StyledEngineProvider, { injectFirst: true },
            React.createElement(ThemeProvider, { theme: theme }, children)));
    }
    return React.createElement(ThemeProvider, { theme: theme }, children);
}
//# sourceMappingURL=Theme.js.map